import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr5 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За безопасна работа при обковаване на телекомуникационни кабели по стените на сградите
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Персоналът, който извършва обковаване </b>на телекомуникационни кабели по стени на
        сгради, трябва да е преминал съответно обучение и инструктаж за безопасна работа и да има не
        по-ниска от трета квалификационна група по безопасност на труда съгласно изискванията на
        Правилника по безопасността на труда при работа по въздушни и кабелни съобщителни линии и
        мрежи (Д-06-001).
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. При работа задължително </b>да се използват одобрените и предоста- вени съобразно
        степента на риска лични предпазни средства, за вида, употребата и начина на съхранение на
        които работещите са инструктирани (и обучени за използването на тези ЛПС, за които това е
        необходимо).
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          3. <span style={styles.warning}>Забранява се </span>
        </b>
        работа с неизправни лични предпазни средства и с такива с изтекъл срок на годност и на
        периодична проверка.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. При обковаване на телекомуникационен кабел </b>по сгради да се използват изправни
        преносими стълби.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          5. <span style={styles.warning}>Забранено е </span>
        </b>
        подаването на материали и инструменти към работещия на стълбата чрез подхвърляне. Подаването
        да става с помощта на въже.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>6. При работа с преносими стълби </b>втори работник трябва да придържа стълбата при
        необходимост.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7. Да не се работи с ръчни електрически инструменти</b> на височина по- голяма от 2,5 m с
        преносима стълба.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          8. <span style={styles.warning}>Забранява се </span>
        </b>
        опирането на преносима еднораменна стълба върху носещо въже или въздушна кабелна линия.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>9. Преди започване на обковаване на телекомуникационни кабели</b> по стени на сгради,
        задължително се почиства мястото от странични предмети, сняг, лед и др.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>10. При успоредно полагане на телекомуникационен кабел </b>с проводници за електрическо
        осветление, светещи реклами, сигнализации и др., телекомуникационния кабел да се полага
        възможно най-далече, но не по-малко от 5 cm по-ниско от тях.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>11. При пресичане на телекомуникационен кабел </b>с проводници на електрическо
        осветление, светещи реклами, сигнализации и др., монтирани по стените на ролки,
        телекомуникационния кабел да се полага под тях, като се поставя в ебонитова или гумена
        тръбичка (шлаух), дълга най-малко 15 cm, която се завързва в двата края, за да не се
        размести от мястото на пресичане. Дебелината на стената на тръбичката да е не по- малка от 2
        mm.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>12. Когато телекомуникационният кабел </b>пресича проводници на електрическо осветление,
        светещи реклами, сигнализации и др., поставени в бергманови тръби, телекомуникационния кабел
        да се полага под тях в канал, направен в мазилката.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>13. Обтегателните халки </b>трябва да се монтират надеждно в стените на сградите
        перпендикулярно на носещото въже.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>14. Преди монтаж на въздушен телекомуникационен кабел </b>върху носещо въже задължително
        се проверява:
      </Typography>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - здравината и правилността на монтажа на обтегателните халки в стената на сградата;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - надеждността на закрепване на обтегача към обтегателната халка.
        </Typography>
      </div>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          15. <span style={styles.warning}>Забранява се </span>
        </b>
        монтирането на носещото въже към дървени елементи, клони, куки и изолатори на
        електрозахранващата мрежа.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr5;
